import clsx from "clsx";
import styles from "./styles.module.scss";

const ICON_SELECTED_BADGE = "../icons/icon-selected-badge.svg";

export interface IButtonCard {
  img: { url: string; alt: string };
  label: string;
  text: string;
  id?: number;
  isSelected: boolean;
  onChange?: (data: number) => void;
  isCursorDefault?: boolean;
}

const ButtonCard = ({
  img,
  label,
  text,
  isSelected,
  id,
  isCursorDefault,
  onChange,
}: IButtonCard) => {
  return (
    <div className={styles.buttonBgImg}>
      <div
        className={clsx(
          styles.buttonBgImg__container,
          isCursorDefault && styles.buttonBgImg__container_cursorDefault
        )}
        onClick={onChange && id ? () => onChange(id) : undefined}
      >
        <div className={styles.buttonBgImg__label}>{label}</div>

        <div className={styles.buttonBgImg__containerImg}>
          <img
            src={img.url}
            alt={img.alt}
            className={clsx(
              styles.buttonBgImg__img,
              isSelected && styles.buttonBgImg__img_bgNone
            )}
          />
        </div>

        <div className={styles.buttonBgImg__text}>{text}</div>

        {isSelected && (
          <div className={styles.buttonBgImg__badge}>
            <img
              src={ICON_SELECTED_BADGE}
              alt="selected"
              className={styles.buttonBgImg__icon}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ButtonCard;
